import { Directive, HostListener, Input } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@zaoblako/web/core/services/security/auth.service';
import { navigateToCard } from '@zaoblako/web/shared/helpers/card-navigation.helper';

@Directive({
  standalone: true,
  selector: '[crmConditionalRouterLink]'
})
export class ConditionalRouterLinkDirective {
  @Input('crmRouterLink') public crmRouterLink: string | any[] | null = null;
  @Input() public queryParams = null;

  public constructor(private readonly router: Router, private readonly authService: AuthService) {}

  @HostListener('click', ['$event'])
  public onClick(event: MouseEvent): void {
    if (!this.crmRouterLink) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    navigateToCard(this.router, this.authService, this.crmRouterLink, this.queryParams);
  }
}
